function getlength(number) {
    return number && number.toString().length;
}
export default getlength;